export const esignTools ={
  "validSuccess": "",
  "valid": "",
  "error": {
    "100010": "",
    "100011": "",
    "100019": "",
    "110011": "",
    "140004": "",
    "140005": "",
    "140006": "",
    "140007": "",
    "140008": "",
    "140009": "",
    "140010": "",
    "unknown": ""
  },
  "validTitle": "",
  "uploadFile": "",
  "currentDoc": "",
  "enterpriseName": "",
  "userName": "",
  "email": "",
  "signatureAuths": "",
  "noAuths": "",
  "canUpload": "",
  "validList": "",
  "validName": {
    "IdP_EntityId": "",
    "SP_EntityId": "",
    "Target_URL": "",
    "X_509": "",
    "ignoreTime": ""
  },
  "validError": {
    "IdP_EntityId": "",
    "SP_EntityId": "",
    "Target_URL": "",
    "X_509": ""
  }
}